// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BranchWithParsedCases } from '../schemas/types/branch-types';

interface BranchesState {
  branches: BranchWithParsedCases[];
  openStates: { [slug: string]: boolean }; // To track open/close state
}

const initialState: BranchesState = {
  branches: [],
  openStates: {}
};

const navigationSlice = createSlice({
  name: 'branches',
  initialState,
  reducers: {
    setBranches: (
      state: BranchesState,
      action: PayloadAction<BranchWithParsedCases[]>
    ) => {
      state.branches = action.payload;
    },
    setOpen: (
      state: BranchesState,
      action: PayloadAction<{ id: string; isOpen: boolean }>
    ) => {
      state.openStates[action.payload.id] = action.payload.isOpen;
    }
  }
});

export const { setBranches, setOpen } = navigationSlice.actions;
export default navigationSlice.reducer;
